import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home.js";
import About from "./pages/About.js";
import Services from "./pages/Services.js";
import ServiceDetail from "./pages/ServiceDetail";
import MembershipPlans from "./pages/MembershipPlans";
import NewsandUpdates from "./pages/NewsandUpdates.js";
import NewsandUpdateDetail from "./pages/NewsandUpdateDetail.js";
import FamiliesCaring from "./pages/FamiliesCaring.js";
import TermsAndConditions from "./pages/TermsAndConditions.js";
import PrivacyPolicy from "./pages/PrivacyPolicy.js";
import Faq from "./pages/Faq.js";
import ContactUs from "./pages/ContactUs.js";
import CreateUser from "./pages/CreateUser.js";
import ScrollToTop from "./components/ScrollToTop.js";
import ConsentOfCare from "./pages/ConsentOfCare.js";
import PatientFamBillOfRights from "./pages/PatientFamBillOfRights.js";
import HippaReleasePrivacy from "./pages/HippaReleasePrivacy.js";

function App() {
  return (
    <div>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:id" element={<ServiceDetail />} />
        {/* <Route path="/membership" element={<MembershipPlans />} /> */}
        <Route path="/news&updates" element={<NewsandUpdates />} />
        <Route
          path="/newsandupdatedetail/:category"
          element={<NewsandUpdateDetail />}
        />
        <Route path="/familiesCaring" element={<FamiliesCaring />} />
        <Route path="/termsandconditions" element={<TermsAndConditions />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/create_user" element={<CreateUser />} />
        <Route path="/consent-of-care" element={<ConsentOfCare />} />
        <Route
          path="/patient-family-bill-of-rights"
          element={<PatientFamBillOfRights />}
        />
        <Route
          path="/hipaa-release-privacy"
          element={<HippaReleasePrivacy />}
        />
      </Routes>
    </div>
  );
}

export default App;
